import i from './pdf-viewer.container';

export default i;
